import axios from '~/axiosWrapper';
import { API } from '~/app/routes';
import { ServiceCheck, ServiceDetails } from '~/types';
import { assertOnlineForRemote } from './remoteGuard';

export class ServiceRemoteDataSource {
  fetchService(id: ServiceDetails['id']): Promise<ServiceDetails> {
    assertOnlineForRemote();
    return axios.get(`${API.service}/${id}`);
  }

  fetchFavoriteServices(scope: string): Promise<ServiceDetails[]> {
    assertOnlineForRemote();
    return axios.get(`${API.service}/${scope}`);
  }

  fetchChecklist(payload: {
    serviceId: ServiceDetails['id'];
    serviceIntervalId: ServiceDetails['serviceIntervalId'];
  }): Promise<ServiceCheck[]> {
    assertOnlineForRemote();
    return axios.post(`${API.service}/checklist`, payload);
  }
}

export const serviceRemote = new ServiceRemoteDataSource();
